import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../assets/ShubhPaisa.svg";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaXTwitter,
} from "react-icons/fa6";

export default function Footer() {
  return (
    <footer className="mt-5">
      <div
        style={{
          backgroundColor: "#2E4463",
          color: "#fff",
          padding: "50px 0",
        }}
      >
        <div className="row d-flex justify-content-center">
          <div className="col-md-10 p-0 col-12">
            <div className=" p-3 text-center text-md-start">
              <h4 className="fw-semibold mb-4 text-center">Services</h4>
              <div className="row justify-content-center">
                <div className="col-6 col-md-2 mb-4">
                  <Link
                    to="/personal-loan"
                    style={{ textDecoration: "none", color: "inherit" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/personal-loan";
                    }}
                  >
                    <h6 className="pb-2 fw-bold" style={{ cursor: "pointer" }}>
                      Personal Loan
                    </h6>
                  </Link>

                  <ul className="list-unstyled small">
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Education Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Medical Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Marriage Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Travel Loan
                    </li>
                  </ul>
                </div>

                <div className="col-6 col-md-2 mb-4">
                  <Link
                    to="/housing-loan"
                    style={{ textDecoration: "none", color: "inherit" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/housing-loan";
                    }}
                  >
                    <h6 className="pb-2 fw-bold" style={{ cursor: "pointer" }}>
                      Housing Loan
                    </h6>
                  </Link>
                  <ul className="list-unstyled small">
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Home Purchase Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Home Construction Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Home Renovation
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Top-up Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Balance Transfer Loan
                    </li>
                  </ul>
                </div>

                <div className="col-6 col-md-2 mb-4">
                  <Link
                    to="/vehicle-loan"
                    style={{ textDecoration: "none", color: "inherit" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/vehicle-loan";
                    }}
                  >
                    <h6 className="pb-2 fw-bold" style={{ cursor: "pointer" }}>
                      Vehicle Loan
                    </h6>
                  </Link>
                  <ul className="list-unstyled small">
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Two-Wheeler Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Car Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Commercial Vehicle Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Electric Vehicle Loan
                    </li>
                  </ul>
                </div>

                <div className="col-6 col-md-2 mb-4">
                  <Link
                    to="/business-loan"
                    style={{ textDecoration: "none", color: "inherit" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/business-loan";
                    }}
                  >
                    <h6 className="pb-2 fw-bold" style={{ cursor: "pointer" }}>
                      Business Loan
                    </h6>
                  </Link>
                  <ul className="list-unstyled small">
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Working Capital Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Term Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      SME/MSME Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Startup Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Machinery/Equipment Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Invoice Financing
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Overdraft Facility
                    </li>
                  </ul>
                </div>

                <div className="col-6 col-md-2 mb-4">
                  <Link
                    to="/gold-loan"
                    style={{ textDecoration: "none", color: "inherit" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/gold-loan";
                    }}
                  >
                    <h6 className="pb-2 fw-bold" style={{ cursor: "pointer" }}>
                      Gold Loan
                    </h6>
                  </Link>
                  <ul className="list-unstyled small">
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Regular Gold Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Business Gold Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Emergency Gold Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Gold Loan Top-up
                    </li>
                  </ul>
                </div>

                <div className="col-6 col-md-2 mb-4">
                  <Link
                    to="/loan-against-property"
                    style={{ textDecoration: "none", color: "inherit" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/loan-against-property";
                    }}
                  >
                    <h6 className="pb-2 fw-bold" style={{ cursor: "pointer" }}>
                      Loan Against Property
                    </h6>
                  </Link>
                  <ul className="list-unstyled small">
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Residential Property Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Commercial Property Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Industrial Property Loan
                    </li>
                    <li
                      className="pb-3"
                      style={{ fontSize: ".8rem", fontWeight: "300" }}
                    >
                      {" "}
                      Lease Rental Discounting
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Middle Section */}
      <div
        style={{
          backgroundColor: "#E9EBF7",
          color: "#333",
          padding: "40px 0",
        }}
      >
        <div className="row d-flex justify-content-center">
          <div className="col-md-10 col-12">
            <div className="row align-items-start">
              <div className="col-12 col-md-4 mb-4 text-center text-md-start">
                <Link to="/">
                  <img
                    src={logo}
                    alt="ShubhPaisa Logo"
                    style={{ width: "180px", maxWidth: "60%" }}
                    className="mb-3"
                  />
                </Link>
                <p className=" text-muted mb-1" style={{ fontSize: ".8rem" }}>
                  {" "}
                  @ Powered By Bumppy Payments
                </p>
                <p className="text-muted mb-0 mx-3 mx-md-0 responsive-text">
                  Our goal is to provide easy-to-use, transparent financial
                  products that cater to the rapidly evolving financial needs of
                  India.
                </p>
              </div>

              <div className="col-12 col-md-2 mb-4 text-center text-md-start">
                <h6 className="fw-bold mb-3">Company</h6>
                <ul className="list-unstyled small d-flex flex-row flex-md-column justify-content-center justify-content-md-start gap-4">
                  <li style={{ fontSize: "1rem" }}>
                    <Link
                      to="/about-us"
                      className="text-decoration-underline text-dark"
                      onClick={(e) => {
                        e.preventDefault();
                        window.location.href = "/about-us";
                      }}
                    >
                      About Us
                    </Link>
                  </li>
                  <li style={{ fontSize: "1rem" }}>
                    <Link
                      to="/careers"
                      className="text-decoration-underline text-dark"
                      onClick={(e) => {
                        e.preventDefault();
                        window.location.href = "/careers";
                      }}
                    >
                      Careers
                    </Link>
                  </li>
                  <li style={{ fontSize: "1rem" }}>
                    <Link
                      to="/blogs"
                      className="text-decoration-underline text-dark"
                      onClick={(e) => {
                        e.preventDefault();
                        window.location.href = "/blogs";
                      }}
                    >
                      Blog
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-12 col-md-2 mb-4 text-center text-md-start">
                <h6 className="fw-bold mb-3">Location</h6>
                <ul className="list-unstyled small d-flex flex-row flex-md-column justify-content-center justify-content-md-start gap-4">
                  <li style={{ fontSize: "1rem" }}>
                    <Link
                      to="/contact"
                      className="text-decoration-underline text-dark"
                      onClick={(e) => {
                        e.preventDefault();
                        window.location.href = "/contact";
                      }}
                    >
                      Contact Us
                    </Link>
                  </li>

                  {/* <li
                    style={{ fontSize: "1rem" }}
                    className="text-decoration-underline text-dark"
                  >
                    Locate us
                  </li> */}
                </ul>
              </div>

              {/* Social Links */}
              <div className="col-12 col-md-4 mb-4 text-center text-md-start">
                <h6 className="fw-bold mb-3">Social Links</h6>

                <div className="d-flex align-items-center gap-3 mb-2 justify-content-center justify-content-md-start">
                  <div
                    className="bg-primary rounded-circle d-flex justify-content-center align-items-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <FaFacebookF className="text-white" size={18} />
                  </div>

                  <div
                    className="bg-primary rounded-circle d-flex justify-content-center align-items-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <FaLinkedinIn className="text-white" size={18} />
                  </div>

                  <div
                    className="bg-primary rounded-circle d-flex justify-content-center align-items-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <FaInstagram className="text-white" size={18} />
                  </div>

                  <div
                    className="bg-primary rounded-circle d-flex justify-content-center align-items-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <FaXTwitter className="text-white" size={18} />
                  </div>
                </div>

                <p className="small mb-1">Support: +91-9898800754</p>
                <p className="small mb-0 mx-3 mx-md-0">
                  Address: Ithum Tower, Tower-B, 218, <br /> Second Floor,
                  Sector 62 Noida-201309
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          backgroundColor: "#F7F7F7",
          padding: "15px 0",
          fontSize: "14px",
        }}
      >
        <div className="row d-flex justify-content-center">
          <div className="col-md-9 col-12">
            <div className=" d-flex flex-column flex-md-row justify-content-between align-items-center">
              <p className="mb-2 mb-md-0 text-muted">
                © 2025 ShubhPaisa Limited
              </p>
              <div>
  <a
    href="/privacy-policy"
    className="text-muted me-3"
    onClick={() => window.location.href = "/privacy-policy"}
  >
    Privacy Policy
  </a>

  <a
    href="/terms-condition"
    className="text-muted"
    onClick={() => window.location.href = "/terms-condition"}
  >
    Terms & Conditions
  </a>
</div>

            </div>
          </div>
        </div>
        <p className="text-center text-muted mb-1">
          {" "}
          Powered By Bumppy Payments
        </p>
      </div>
    </footer>
  );
}
